exports.DIGITAL_BILL_FORM = 2;
exports.QUALITY = 'quality';
exports.WARRANTY = 'warranty';
